module.exports = __webpack_public_path__ + "img/menu-hair-5.001411f6.webp";